/**
 * Spinner — accessible loading indicator with an optional label.
 *
 * Uses aria-busy + role="status" and a visible label so screen readers
 * announce the loading state.
 */
import styles from './Spinner.module.css';

export interface SpinnerProps {
  /** Visible + accessible label describing what is loading. */
  label?: string;
  /** Diameter in pixels; defaults to 32. */
  size?: number;
}

/** Render a circular spinner with an optional accessible label. */
export function Spinner({ label, size = 32 }: SpinnerProps) {
  const style = size !== 32 ? { width: size, height: size } : undefined;
  return (
    <div className={styles.wrap} role="status" aria-busy="true">
      <span className={styles.spinner} style={style} aria-hidden="true" />
      {label ? <span className={styles.label}>{label}</span> : null}
    </div>
  );
}
